export const extractBibValue = (value: string) => {
  return (value.match(/\/bib\/(\d+)$/) || [])[1] ?? value.replace(/\D/g, '')
}
